<template>
  <div>
    <the-header ref="theHeader" />
    <!-- <div class="d-flex justify-content-center">
      <iframe
        width="80%"
        height="850vh"
        src="https://forms.office.com/r/P8wapxFcGN?embed=true"
        frameborder="0"
        marginwidth="0"
        marginheight="0"
        style="border: none; max-width: 100%; max-height: 100vh"
        allowfullscreen
        webkitallowfullscreen
        mozallowfullscreen
        msallowfullscreen
      >
      </iframe>
    </div> -->
    <div class="paperform-wrapper">
      <!-- The target div where Paperform will render -->
      <div data-paperform-id="6wloiz3f"></div>
    </div>

    <the-footer />
  </div>
</template>

<script>
import theHeader from '../../about/layout/theHeader.vue';
import theFooter from '../../about/layout/theFooter.vue';

export default {
  name: 'PaperformEmbed',
  components: {
    theHeader,
    theFooter,
  },
  data() {
    return {
      title: '',
      configObject: {}, // This should be an Object initially
      url: 'https://forms.office.com/r/P8wapxFcGN?embed=true',
      width: '80%',
      height: '800',
      showComing: true,
    };
  },

  mounted() {
    const scriptId = 'paperform-embed-script';
    const existingScript = document.getElementById(scriptId); // Remove the script if it already exists so it re-triggers on returning to the page

    if (existingScript) {
      existingScript.remove();
    } // Create and inject the script

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = 'https://paperform.co/__embed.min.js';
    script.async = true;
    document.body.appendChild(script);
  },
};
</script>

<style lang="scss" scoped></style>
